<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="dedf"><a class="page" id="pv"></a>For Geoffrey Hartman</p>
<p class="ded">In memoriam</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-liu-0005.vue?6656bbc1